import React, { Component } from 'react';
import Spinner from '../../Spinner/Spinner';

const ID_PREFIX = 'store-app-products';

class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inProgress: false,
      id: `${ID_PREFIX}-${Math.floor(Math.random() * 1001)}`
    };
  }

  showProductCarousel(settings) {
    const productCarouselControl = window.ow.controls.productCarouselControl;

    this.setState({
      inProgress: true
    });
    const timeoutId = window.setTimeout(() => {
      window.clearTimeout(timeoutId);
      if (this.state.inProgress) {
        this.setState({
          inProgress: false
        });
      }
    }, 5000);

    productCarouselControl.showProductCarousel(settings);
  }

  componentDidMount() {
    if (
      !(
        process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test'
      )
    ) {
      return;
    }

    window.$(document).on('espotLoaded', () => {
      this.setState({
        inProgress: false
      });
    });
    const settings = (window.ow.state.carousel.settings[this.state.id] = {
      SKUs: this.props.contentBlock.skus,
      targetDivId: this.state.id,
      templateName: 'product-grid-view',
      espotTitle: ''
    });

    this.showProductCarousel(settings);
  }

  render() {
    if (
      !(
        process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test'
      )
    ) {
      return <div>Products: {this.props.contentBlock.skus}</div>;
    }

    return (
      <React.Fragment>
        {this.state.inProgress && <Spinner />}
        <div id={this.state.id} />
      </React.Fragment>
    );
  }
}

export default Products;



// WEBPACK FOOTER //
// ./src/components/content-blocks/Products/Products.js